import React from 'react';

// Mobile Header Component
export const MobileHeader = ({ title, onBack, rightAction }) => (
  <div className="bg-blue-600 text-white p-4 flex items-center justify-between sticky top-0 z-50">
    {onBack && (
      <button onClick={onBack} className="p-1">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
    )}
    <h1 className="text-lg font-semibold flex-1 text-center">{title}</h1>
    <div className="w-8">
      {rightAction}
    </div>
  </div>
);
